import { CreateTypes } from 'canvas-confetti';
import React, { Component, forwardRef, useImperativeHandle } from 'react';
import ReactCanvasConfetti from '../../../common/ReactCanvasConfetti';

interface ConfettiProps {}

export interface ConfettiRef {
  startFire: () => void;
}

const Confetti = forwardRef<ConfettiRef, ConfettiProps>((props, ref) => {
  const animationInstance = React.useRef<CreateTypes | null>(null);
  const isAnimationEnabled = React.useRef(false);

  const makeShot = (particleRatio: number, opts: object) => {
    try {
      if (
        animationInstance.current &&
        typeof animationInstance.current === 'function'
      ) {
        animationInstance.current({
          ...opts,
          origin: { x: 0.5, y: 1 },
          particleCount: Math.floor(200 * particleRatio),
        });
      }
    } catch (error) {
      console.error('Error in makeShot:', error);
    }
  };

  const fire = () => {
    try {
      // window 객체와 screen 속성의 존재 여부 확인
      const w =
        typeof window !== 'undefined' && window.screen
          ? window.screen.width
          : 1920;
      const h =
        typeof window !== 'undefined' && window.screen
          ? window.screen.height
          : 1080;
      const power = (w * h) / 8000;

      makeShot(0.25, {
        spread: 70,
        startVelocity: power,
        colors: ['#ffd254', '#fff', '#d5a444'],
      });
    } catch (error) {
      console.error('Error in confetti fire:', error);
      // 기본값으로 fallback
      makeShot(0.25, {
        spread: 70,
        startVelocity: 30,
        colors: ['#ffd254', '#fff', '#d5a444'],
      });
    }
  };

  const handlerFire = () => {
    try {
      if (!isAnimationEnabled.current) {
        isAnimationEnabled.current = true;
      }

      if (typeof requestAnimationFrame !== 'undefined') {
        requestAnimationFrame(fire);
      }
      fire();
    } catch (error) {
      console.error('Error in handlerFire:', error);
    }
  };

  useImperativeHandle(ref, () => ({
    startFire: handlerFire,
  }));

  const getInstance = (instance: CreateTypes | null) => {
    animationInstance.current = instance;
  };

  return (
    <ReactCanvasConfetti
      refConfetti={getInstance}
      className="canvas pointer-events-none h-full w-full"
    />
  );
});

export default Confetti;
